"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.findMinterAddress = exports.findMintWrapperAddress = void 0;
const anchor_1 = require("@project-serum/anchor");
const web3_js_1 = require("@solana/web3.js");
const constants_1 = require("../../constants");
const findMintWrapperAddress = (base, programID = constants_1.SUNNY_ADDRESSES.MintWrapper) => __awaiter(void 0, void 0, void 0, function* () {
    return yield web3_js_1.PublicKey.findProgramAddress([Buffer.from(anchor_1.utils.bytes.utf8.encode("MintWrapper")), base.toBytes()], programID);
});
exports.findMintWrapperAddress = findMintWrapperAddress;
const findMinterAddress = (wrapper, authority, programID = constants_1.SUNNY_ADDRESSES.MintWrapper) => __awaiter(void 0, void 0, void 0, function* () {
    return yield web3_js_1.PublicKey.findProgramAddress([
        Buffer.from(anchor_1.utils.bytes.utf8.encode("MintWrapperMinter")),
        wrapper.toBytes(),
        authority.toBytes(),
    ], programID);
});
exports.findMinterAddress = findMinterAddress;
//# sourceMappingURL=pda.js.map